export function LegalView() {
  return (
    <section id={"legal-view"} class={"legal-page"} hidden>
      <header class={"legal-page-header"}>
        <a class={"brand-lockup compact legal-brand"} href={"/"} aria-label={"kUni"}>
          <img class={"brand-symbol small"} src={"/assets/icon.svg"} alt={""} />
          <span class={"brand-wordmark compact"} aria-hidden={"true"}>
            {"kUn"}
            <span class={"brand-i"}>
              {"ı"}
            </span>
          </span>
        </a>
        <button class={"button small"} type={"button"} id={"legal-back"} data-ui-text={"legal.page.back"}></button>
      </header>
      <main class={"legal-page-main"}>
        <article id={"legal-document"} class={"legal-document"}></article>
      </main>
    </section>
  );
}
